import { customHTMLSerializer } from '@/utils/customHTMLSerializer';
import { jsonToHtml, jsonToMarkdown } from '@contentstack/json-rte-serializer';
import React from 'react';

export default function rte(content, options = {}) {
  if (!content) return null;

  const htmlContent = jsonToHtml(content, customHTMLSerializer(options));

  return htmlContent;
}

// BL-654: swallow malformed RTE payloads instead of crashing the block
// mirrors the private guards already in Faq, FaqGrid, IdMeHero.
export function renderRte(content, options = {}) {
  if (!content) return '';
  try {
    return rte(content, options) ?? '';
  } catch {
    return '';
  }
}

// BL-512: an RTE link with target="_blank" has to say so. BL-474 solved this for
// the footer with a local `a` handler; this is the same behaviour, shared, so the
// next block that renders RTE does not need a fifth copy of the serializer.
//
// `className` is per caller because the styling differs by surface — the footer
// underlines on its dark panel, blocks inherit their own link colour. Also strips
// the stray `url` attr the RTE serializer leaves behind once a custom `a` handler
// is registered.
export function outboundLinkHandler(className = '') {
  const cls = className ? ` class="${className}"` : '';
  return (attrs, child) => {
    const cleanAttrs = attrs.replace(/\s*url="[^"]*"/, '');
    return attrs.includes('target="_blank"')
      ? `<a${cleanAttrs}${cls}>${child}<span class="sr-only"> (opens in a new tab)</span></a>`
      : `<a${cleanAttrs}${cls}>${child}</a>`;
  };
}

export function rteHasContent(content) {
  if (!content) {
    return false;
  }

  return jsonToMarkdown(content).trim() !== '';
}

export function rteToPlainText(content) {
  if (!content) {
    return false;
  }  

  return content.children.reduce((acc, child) => {
    return `${acc}${child.children.reduce((childAcc, childChild) => `${childAcc}${childChild.text}`, '')}`;
  }, '');
}

export function isRte(content) {
  return (
    typeof content === 'object' &&
    !Array.isArray(content) &&
    !React.isValidElement(content) &&
    content !== null
  );
}

// usage example in /utils/README.md
